export function rejoinMedia(saved?: { audioEnabled?: boolean; videoEnabled?: boolean }): {
  audioEnabled: boolean
  videoEnabled: boolean
} {
  return {
    audioEnabled: saved?.audioEnabled ?? true,
    videoEnabled: saved?.videoEnabled ?? true,
  }
}
